/* eslint-disable */
export default function load(module) {
  switch(module) {
    case '@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab':
      return Promise.resolve(window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab'));
    case '@bingads-webui-component-legacy/http/channel/odata':
      return import(/* webpackChunkName: "settings-page-dynamic-feature-odata" */ '@bingads-webui-component-legacy/http/channel/odata').then(legacyModule => legacyModule.default);
    case '@bingads-webui-component-legacy/config/index':
      return import(/* webpackChunkName: "settings-page-dynamic-feature-config" */ '@bingads-webui-component-legacy/config/index').then(legacyModule => legacyModule.default);
    case '@bingads-webui-campaign-legacy/instrumentation/index':
      return import(/* webpackChunkName: "settings-page-dynamic-feature-instrumentation" */ '@bingads-webui-campaign-legacy/instrumentation/index');
    case '@bingads-webui-campaign/recommendation-inline-budget-view':
      return import(/* webpackChunkName: "settings-page-dynamic-feature-inline-budget" */ '@bingads-webui-campaign/recommendation-inline-budget-view');
    default:
      return new Promise(null);
  }
}
